import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  page: null,
  limit: null,
  totalPages: null,
  totalResults: null,
  entities: [],
  listLoading: false,
  actionLoading: false,
  selectedEmailTemplate: null,
};

export const emailTemplateSlice = createSlice({
  name: "emailTemplates",
  initialState: initialState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    stopCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    getEmailTemplates: (state, action) => {
      const { emailTemplates, page, limit, totalPages, totalResults } = action?.payload;
      state.entities = emailTemplates;
      state.page = page;
      state.limit = limit;
      state.totalPages = totalPages;
      state.totalResults = totalResults;
      state.listLoading = false;
    },
    setSelectedEmailTemplate: (state, action) => {
      const { emailTemplate } = action.payload;
      state.selectedEmailTemplate = emailTemplate;
      state.actionLoading = false;
    },
  },
});
